<template>
  <b-overlay
      :show="$store.getters['slsImagemHome/getIsLoading']"
      rounded="sm"
  >
    <div class="position-absolute" style="top: -50px;right: 0">
      <b-button variant="outline-primary" class="mr-2" :to="{name: 'imagens-home-list'}">Cancelar</b-button>
      <b-button
          variant="primary"
          @click="handleSubmit"
      >
        {{ isEditDisabled ? 'Editar' : 'Salvar' }}
      </b-button>
    </div>
    <validation-observer ref="refFormCreateImagemHomeEdit">
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Configurar Imagem</span>
              </b-card-title>
              <b-row>
                <b-col cols="12" sm="4">
                  <b-form-group label="Marca">
                    <validation-provider
                        #default="{ errors }"
                        name="Marca"
                        rules="required"
                    >
                      <b-form-select
                          v-model="imagemHome.cod_marca"
                          label-field="text"
                          :state="errors.length > 0 ? false:null"
                          value-field="value"
                          :options="$store.getters['slsImagemHome/getOptionsMarcas']"
                          :disabled="isEditDisabled"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label="Imagem">
                      <b-form-file
                          ref="refCaminho"
                          v-model="imagemHome.caminho"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          accept="image/*"
                          @drop.prevent="changeImg($event, 'refCaminho')"
                          @change="changeImg($event, 'refCaminho')"
                          :disabled="isEditDisabled"
                      ></b-form-file>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="8" class="d-flex justify-content-center">
                  <b-form-group>
                    <div class="molde-img">
                      <b-img
                          v-if="imagemPresenter.caminho !== ''"
                          :src="imagemPresenter.caminho"
                          fluid alt="Responsive image"
                          width="261"
                          height="350"
                          style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
                      />
                      <div class="box-img-empty" v-else>
                        <b-img icon="image" font-scale="2" class="text-white"></b-img>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="4">
                  <b-form-group label="Catálogo">
                      <b-form-file
                          v-model="imagemHome.caminho_catalogo"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          :disabled="isEditDisabled"
                          accept=".pdf"
                      ></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col cols="12">

                  <b-form-group label="Ordem Apresentação na Home">
                      <b-row>
                        <b-col cols="12" sm="2">
                          <b-form-input
                              v-model="imagemHome.ordem_visualizacao"
                              type="number"
                              placeholder="Ex. 2"
                              :disabled="isEditDisabled"
                          />
                        </b-col>
                      </b-row>
                  </b-form-group>

                </b-col>

              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Cadastro Imagem Cabeçalho Tela Marcas</span>
              </b-card-title>
              <b-row>
                <b-col cols="12" sm="8">
                  <b-form-group label="Cor cabeçalho página marcas">

                    <b-row class="mb-3">
                      <b-col cols="12" sm="4">
                        <b-form-input
                            type="color"
                            v-model="imagemHome.cor_cabecalho_marca"
                            :disabled="isEditDisabled"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" sm="6">
                        <b-form-group label="Imagem do Cabeçalho Marcas">
                            <b-form-file
                                v-model="imagemHome.caminho_img_cabec_marcas"
                                placeholder="Escolha um arquivo ou arraste-o aqui..."
                                drop-placeholder="Solte o arquivo aqui..."
                                accept="image/*"
                                @change="changeImg($event, 'caminho_img_cabec_marcas')"
                                @drop="changeImg($event, 'caminho_img_cabec_marcas')"
                                :disabled="isEditDisabled"
                            ></b-form-file>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                  <b-col cols="12" sm="8" class="d-flex justify-content-center">
                    <b-form-group>

                      <div>
                        <b-img
                            v-if="imagemPresenter.caminho_img_cabec_marcas !== ''"
                            :src="imagemPresenter.caminho_img_cabec_marcas"
                            fluid
                            alt="Imagem do Cabeçalho Marcas"
                            :style="{ 'background-color': imagemHome.cor_cabecalho_marca }"
                            width="250"
                            height="100"
                            style="max-width: 250px; max-height: 100px;min-width: 250px; min-height: 100px;"
                        />
                        <div class="box-img-empty-primary-secondary" v-else
                             :style="{ 'background-color': imagemHome.cor_cabecalho_marca }">
                          <b-img
                              icon="image"
                              font-scale="2"

                              class="text-white"
                          ></b-img>
                        </div>
                      </div>

                    </b-form-group>
                  </b-col>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Cadastro Imagem rodapé</span>
              </b-card-title>
              <b-row class="mb-5">
                <b-col cols="12" sm="4">
                  <b-form-group label="Imagem do rodapé principal">
                      <b-form-file
                          v-model="imagemHome.caminho_img_footer_principal"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          accept="image/*"
                          @change="changeImg($event, 'caminho_img_footer_principal')"
                          @drop="changeImg($event, 'caminho_img_footer_principal')"
                          :disabled="isEditDisabled"
                      ></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="8" class="d-flex justify-content-center">
                  <b-form-group>
                    <div>
                      <b-img
                          v-if="imagemPresenter.caminho_img_footer_principal !== ''"
                          :src="imagemPresenter.caminho_img_footer_principal"
                          fluid
                          alt="Roda pé principal"
                          width="250"
                          height="100"
                          style="max-width: 250px; max-height: 100px;"
                      />
                      <div class="box-img-empty-primary-secondary" v-else>
                        <b-img icon="image" font-scale="2" class="text-white"></b-img>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="4">
                  <b-form-group label="Imagem do rodapé secundária">
                      <b-form-file
                          v-model="imagemHome.caminho_img_footer_secundaria"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          accept="image/*"
                          @change="changeImg($event, 'caminho_img_footer_secundaria')"
                          @drop="changeImg($event, 'caminho_img_footer_secundaria')"
                          :disabled="isEditDisabled"
                      ></b-form-file>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="8" class="d-flex justify-content-center">
                  <b-form-group>
                    <div>
                      <b-img
                          v-if="imagemPresenter.caminho_img_footer_secundaria !== ''"
                          :src="imagemPresenter.caminho_img_footer_secundaria"
                          fluid
                          alt="Roda pé secundário"
                          width="250"
                          height="100"
                          style="max-width: 250px; max-height: 100px;"
                      />
                      <div class="box-img-empty-primary-secondary" v-else>
                        <b-img icon="image" font-scale="2" class="text-white"></b-img>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@core/utils/validations/validations';
import HbiImagemHomeService from '@/services/SistemaDKP/sls-imagem-home.service';

const imagemHomeService = new HbiImagemHomeService();
export default {
  name: 'EditIndex',
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
      imagemHomeService,
      isEditDisabled: true,
      imagemPresenter: {
        caminho: '',
        caminho_img_cabec_marcas: '',
        caminho_img_footer_principal: '',
        caminho_img_footer_secundaria: '',
      },
    };
  },
  computed: {
    imagemHome: {
      get() {
        return this.$store.getters['slsImagemHome/getCurrentImagemHome'];
      },
      set(value) {
        this.$store.commit('slsImagemHome/setCurrentImagemHome', value);
      },
    },
    getCopyCurrentImagemHome(state) {
      return this.$store.getters['slsImagemHome/getCopyCurrentImagemHome'];
    },
  },
  methods: {
    isNotNull(val) {
      return val !== null;
    },
    handleSubmit() {
      if (this.isEditDisabled) {
        this.isEditDisabled = !this.isEditDisabled;
        return;
      }
      this.$refs.refFormCreateImagemHomeEdit.validate().then(async (valid) => {
        if (valid) {
          await this.imagemHomeService.update({
            ...this.imagemHome,
            caminho_catalogo: this.isNotNull(this.imagemHome.caminho_catalogo) ? this.imagemHome.caminho_catalogo : this.imagemPresenter.caminho_catalogo,
            caminho: this.isNotNull(this.imagemHome.caminho) ? this.imagemHome.caminho : this.imagemPresenter.caminho,
            caminho_img_cabec_marcas: this.isNotNull(this.imagemHome.caminho_img_cabec_marcas) ? this.imagemHome.caminho_img_cabec_marcas : this.imagemPresenter.caminho_img_cabec_marcas,
            caminho_img_footer_principal: this.isNotNull(this.imagemHome.caminho_img_footer_principal) ? this.imagemHome.caminho_img_footer_principal : this.imagemPresenter.caminho_img_footer_principal,
            caminho_img_footer_secundaria: this.isNotNull(this.imagemHome.caminho_img_footer_secundaria) ? this.imagemHome.caminho_img_footer_secundaria : this.imagemPresenter.caminho_img_footer_secundaria,
          })
            .then(async () => {
              await this.$refs.refFormCreateImagemHomeEdit.reset();
              await this.$router.push({ name: 'imagens-home-list' });
            });
        }
      });
    },
    changeImg(event, nameVar) {
      event.preventDefault();
      let file = null;
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0];
      } else {
        file = event.target.files[0];
      }

      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const newNameVar = nameVar.replace('ref', '').toLowerCase();
          this.imagemPresenter[newNameVar] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
  },
  async mounted() {
    if (typeof this.$route.params.id !== 'undefined') {
      await imagemHomeService.findById(this.$route.params.id);

      this.imagemPresenter.caminho_catalogo = this.getCopyCurrentImagemHome.caminho_catalogo;
      this.imagemPresenter.caminho = this.getCopyCurrentImagemHome.caminho;
      this.imagemPresenter.caminho_img_cabec_marcas = this.getCopyCurrentImagemHome.caminho_img_cabec_marcas;
      this.imagemPresenter.caminho_img_footer_principal = this.getCopyCurrentImagemHome.caminho_img_footer_principal;
      this.imagemPresenter.caminho_img_footer_secundaria = this.getCopyCurrentImagemHome.caminho_img_footer_secundaria;
    }
    await imagemHomeService.findAllMarcars();
  },
};
</script>

<style scoped lang="scss">
.molde-img {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;

  img {
    padding: 10px;
    height: 100%;
    width: 100%;
  }
}

.box-img-empty {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 400px;

  img {
    padding: 10px;
    max-height: 300px;
  }
}

.box-img-empty-primary-secondary {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 250px;

  img {
    padding: 10px;
    max-height: 100px;
    max-width: 250px;
  }
}

</style>
